import React from 'react';
import { QuoteIcon } from 'lucide-react';
const useCases = [{
  id: 'meta-ads',
  title: 'Ad platform targeting',
  description: 'Upload enriched local business contacts to create highly specific custom audiences on platforms like Meta Ads.',
  quote: 'Our ROAS doubled when we switched from broad interest targeting to Openmart custom audiences.',
  author: 'James T., Growth marketer'
}, {
  id: 'email-outreach',
  title: 'Local business email outreach',
  description: 'Use Openmart to extract targeted local business lists with direct owner emails for cold outreach campaigns.',
  quote: 'We get a 15% reply rate because we can personalize emails using the 50+ data fields provided.',
  author: 'Sarah M., Demand gen lead'
}, {
  id: 'market-expansion',
  title: 'Market expansion campaigns',
  description: 'Analyze local markets at scale and instantly build contact lists for new city or state launches.',
  quote: 'We launched in 5 new cities last month and had our local business marketing lists ready in minutes.',
  author: 'David C., Marketing director'
}];
export function MarketingUseCases() {
  return <section className="py-24 bg-white border-t border-slate-100" data-id="element-5127">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5128">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5129">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-5130">
            Local business marketing data for{' '}
            <span className="text-blue-600" data-id="element-5131">every channel</span>
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-5132">
            Whether you're running social ads, sending cold emails, or launching
            direct mail campaigns — our data powers your growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-5133">
          {useCases.map(useCase => <div key={useCase.id} className="bg-slate-50 rounded-3xl p-8 flex flex-col justify-between" data-id="element-5134">
              <div data-id="element-5135">
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-5136">
                  {useCase.title}
                </h3>
                <p className="text-base text-slate-600 leading-relaxed" data-id="element-5137">
                  {useCase.description}
                </p>
              </div>
              <div className="mt-8 pt-6 border-t border-slate-200" data-id="element-5138">
                <QuoteIcon className="w-5 h-5 text-blue-200 mb-2" data-id="element-5139" />
                <p className="text-base text-slate-700 italic leading-relaxed" data-id="element-5140">
                  {useCase.quote}
                </p>
                <p className="text-sm font-semibold text-slate-400 mt-3 uppercase tracking-wider" data-id="element-5141">
                  — {useCase.author}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}